const ROLES = {
    ROLE_TUTOR : 'Преподаватель',
    ROLE_METHODIST : 'Методист',
    ROLE_SUPER_ADMIN : 'Администратор',
    ROLE_USER : 'Студент',
};
export default ROLES;
